<template>
    <div id="app">
        <Loading />
        <div v-if="loaded" ref="main" id="main">
            <div class="class-panel" :style="isShowTabContainer ? 'right: 290px;' : 'right: 0;'">
                <!--                <WhiteBorad />-->
                <!-- 老师播放器 -->
                <TeacherPlayer />
            </div>
            <div
                class="fold-btn"
                :class="isShowTabContainer ? '' : 'fold-btn-left'"
                @click="onClickFoldBtn"
            >
                <span v-if="isShowTabContainer">></span>
                <span v-else><</span>
            </div>
            <div class="media-panel" :style="isShowTabContainer ? 'right: 0;' : 'right: -290px;'">
                <div class="wrap">
                    <!-- 老师播放器 -->
                    <!--                    <TeacherPlayer />-->
                    <!-- 互动区 -->
                    <InteractionPanel :liveInfo="liveInfo" />
                </div>
                <!-- 文档列表 -->
                <DocList v-if="isTeacher" />
            </div>

            <div class="footer">
                <SettingPanel />
                <FunctionPanel :liveInfo="liveInfo" />
            </div>

            <!-- 模态框组件 -->
            <ModalPanel />
        </div>
        <div id="survey-container" v-if="surveyUrl">
            <iframe ref="iframe" :src="surveyUrl" />
        </div>
        <WaitDialog />
    </div>
</template>

<script>
import WaitDialog from './components/WaitDialog.vue'
// loading组件，进教室之前的准备工作
import Loading from './components/Loading.vue'
// 白板组件
import WhiteBorad from './components/WhiteBoard.vue'
// 设置面板：扬声器、麦克风、摄像头、设置
import SettingPanel from './components/SettingPanel'
// 交互面板：用户列表、聊天、发言列表
import InteractionPanel from './components/InteractionPanel'
// 老师播放器
import TeacherPlayer from './components/TeacherPlayer'
// 功能面板：直播间的一些功能，举手、屏幕共享、弹幕之类
import FunctionPanel from './components/FunctionPanel'
// 模态框组件，在老师端发起互动后显示
import ModalPanel from './components/ModalPanel'
// 跑马灯组件
// 文档列表
import DocList from './components/DocList'
// 话术
import language from './language/main.js'
// 互动组件

const eventEmitter = BJY.eventEmitter
const auth = BJY.auth
const store = BJY.store
const config = BJY.config

eventEmitter.OPEN_SETTING_DIALOG_TRIGGER = 'open_setting_dialog'

export default {
    props: ['liveInfo'],
    components: {
        Loading,
        WhiteBorad,
        SettingPanel,
        InteractionPanel,
        TeacherPlayer,
        FunctionPanel,
        ModalPanel,
        DocList,
        WaitDialog,
    },
    data() {
        return {
            loaded: false,
            webrtc: 1,
            isTeacher: false,
            surveyUrl: '',

            isShowTabContainer: true,
        }
    },
    created() {
        // 绑定事件
        const _this = this
        let $body = $('body')

        store.watch(
            'class.started',
            (started) => {
                if (started === true) {
                    console.log(language.TIP_CLASS_START)
                    _this.$emit('liveStatusChange', eventEmitter.CLASS_START)
                } else if (started === false) {
                    console.log(language.TIP_CLASS_END)
                    _this.$emit('liveStatusChange', eventEmitter.CLASS_END)
                }
            },
            true
        )

        eventEmitter
            .one(eventEmitter.ROOM_SERVER_LOGIN_KICKED_OUT, (event, data) => {
                var _timer = setInterval(() => {
                    var _text = $('.bjy-loading-content .bjy-progress-desc').text()
                    if ('您已被请出教室，本课节无法再次进入' === _text) {
                        $('.bjy-loading-content .bjy-progress-desc').html(
                            `你已被请出教室，本课节无法再次进入<br />直播间出现异常 01`
                        )
                        clearInterval(_timer)
                        return
                    }
                }, 10)
                setTimeout(() => {
                    clearInterval(_timer)
                }, 3000)
            })
            .one(eventEmitter.CLASSROOM_CONNECT_TRIGGER, (event, data) => {
                // 初始化扩展
                var extension = BJY.getExtension()

                // 是否准备好上麦
                const _state = window.sessionStorage.getItem('prepareSpeakStatus') == 1;
                if (!_state) {
                    extension = BJY.Player.html
                }

                if (BJY.browser.wechat) {
                    extension = BJY.Player.html
                }
                // PC 不支持 m3u8，这里强制使用 flv
                if (extension === BJY.Player.html) {
                    extension.extensions.useFlv = true
                }
                // 如果您使用的是webrtc拓展的话，请确保引入了realtimecat.js这个依赖，否则此处会报undefined：RTCat
                extension.init().then(() => {
                    eventEmitter.trigger(eventEmitter.CLASSROOM_CONNECT_TRIGGER, data)
                })
                return false
            })
        eventEmitter
            .on(eventEmitter.CLASSROOM_CONNECT_FAIL, () => {
                alert(language.ROOM_SERVER_CONNECT_FAIL)
            })
            .on(eventEmitter.LOGIN_CONFLICT, () => {
                _this.$emit('liveStatusChange', eventEmitter.LOGIN_CONFLICT)
            })
            // 监听初始化事件，初始化组件
            // 请将所有的组件创建逻辑写于此回调函数之中
            .one(eventEmitter.VIEW_RENDER_TRIGGER, () => {
                console.log(eventEmitter.VIEW_RENDER_TRIGGER)
                // 注意，在VIEW_RENDER_TRIGGER事件触发后再去加载教室里面的组件
                this.loaded = true
                this.isTeacher = auth.isTeacher()
                eventEmitter.trigger(eventEmitter.DOC_ALL_REQ)

                if (auth.isTeacher() || auth.isAssistant()) {
                    store.set('class.speakState', config.SPEAK_STATE_FREE)
                } else {
                    store.set('class.speakState', config.SPEAK_STATE_LIMIT)
                }

                if (auth.isPresenter() && store.get('class.started')) {
                    setTimeout(() => {
                        var player = BJY.Player.instances[BJY.store.get('user.id')]
                        BJY.userPublish.setDevice(player, !player.videoOn, !player.audioOn)
                    }, 1000)
                }

                if (auth.isStudent()) {
                    $body.addClass('student')
                }

                // 初始化webRTC的屏幕扩展
                // 如果你需要使用到webrtc屏幕共享的话，记得在index.html里面引入对应的js依赖
                if (auth.isWebRTC()) {
                    BJY.ScreenShareExtensionWebrtc.init()
                }

                // 转播
                if (BJY.is.isMixWebRTC() && !!store.get('partner.liveRoomBroadcast')) {
                    var TransferClass = BJY.TransferClass
                    var transferClass = new TransferClass()
                    transferClass && transferClass.get()
                }

                _this.$emit('liveStatusChange', 'c_class_show')
            })
            .one(eventEmitter.LOADING_PANEL_END, () => {
                console.log(eventEmitter.LOADING_PANEL_END)
                // 进度条加载完成再显示ui
                // $('#main').css('opacity', 1)
            })
            .on(eventEmitter.CLASS_END, () => {
                // 下课后所有人自动关闭音视频
                eventEmitter.trigger(eventEmitter.MEDIA_SWITCH_TRIGGER, {
                    audioOn: false,
                    videoOn: false,
                })
                _this.$emit('liveStatusChange', eventEmitter.CLASS_END)
            })
            .on(eventEmitter.CLASS_START, () => {
                // 老师上课自动打开音视频
                if (auth.isPresenter()) {
                    setTimeout(() => {
                        var player = BJY.Player.instances[BJY.store.get('user.id')]
                        BJY.userPublish.setDevice(player, !player.videoOn, !player.audioOn)
                    }, 1000)
                }
            })
            .on(eventEmitter.CLASSROOM_CONNECT_SUCCESS, (event, data) => {
                // data.reconnect 是否为断线重连
            })
            // 踢出教室
            .on(eventEmitter.COMMAND_RECEIVE, (event, data) => {
                if (data.command && data.command.command_type === 'logout' && data.toId === store.get('user.id')) {
                    console.log('你已被踢出教室')
                    console.log(eventEmitter.KICK_OUT, event)
                    _this.$emit('liveStatusChange', eventEmitter.KICK_OUT)
                }
            })
            // 课前问卷
            .on(eventEmitter.INTERFACE_FETCH_SUCCESS, () => {
                let isSdk = true
                // 设置为 false 时，检测到需要填写问卷时，会直接重定向
                let noRedirect = true
                BJY.checkQuestionnaireAndTurn(
                    store.get('class.id'),
                    store.get('token'),
                    store.get('user.type'),
                    store.get('user.number'),
                    isSdk,
                    noRedirect
                ).then((data) => {
                    if (data && data.isNeedFill) {
                        this.surveyUrl = data.url
                        let me = this
                        window.onmessage = function (e) {
                            console.log('onmessage', e.data)
                            let data = e.data
                            if (data.type === 'surveyClose' && data.isSubmit) {
                                me.surveyUrl = ''
                            }
                        }
                    }
                })
            })
            .on(eventEmitter.KICK_OUT + this.namespace, (event, data) => {
                console.log(eventEmitter.KICK_OUT, event)
                _this.$emit('liveStatusChange', eventEmitter.KICK_OUT)
            })

        // 初始化教室
        this.init()
    },
    methods: {
        init() {
            console.log('******************************************************************************')
            console.log('*   欢迎使用 BJY JS SDK - 百家云直播 - ' + BJY.version)
            console.log('*   API 文档：https://www.baijiayun.com/js-sdk/doc/#/README')
            console.log('*   版本更新日志：https://www.baijiayun.com/js-sdk/doc/#/change-log')
            console.log(
                '*   常见问题：https://www.baijiayun.com/js-sdk/doc/#/live?id=%e5%b8%b8%e8%a7%81%e9%97%ae%e9%a2%98'
            )
            console.log('*   注意事项：自己创建教室测试时，注意非webrtc类型教室传入webrtc: 0')
            console.log('*   sign签名规则：https://dev.baijiayun.com/wiki/detail/1')
            console.log('******************************************************************************')
            // 默认demo教室-学生端
            var options = {
                env: 'production',
                prefixName: this.liveInfo.domain,
                room_id: this.liveInfo.liveId,
                user_number: this.liveInfo.uid,
                user_avatar: this.liveInfo.avatar,
                user_name: this.liveInfo.nickname,
                user_role: this.liveInfo.role,
                sign: this.liveInfo.accessToken,
                //默认不开启
                webrtc: this.liveInfo.webrtc || 0,
            }

            // debug 模式支持输入传送门链接进入
            // 非webrtc大班课需要在url后拼上 &webrtc=0
            if (location.href.includes('debug=1')) {
                var url = prompt('输入教室链接进入教室')
                options = Object.assign(options, this.urlParser(url))
                console.log(options)
            }

            var classOption = {
                // 必须为字符串
                id: options.room_id,
                // 学生默认限制发言
                speakState: BJY.config.SPEAK_STATE_LIMIT,
            }
            if (Number(options.webrtc)) {
                classOption.webrtcType = Number(options.webrtc)
            }
            this.webrtc = classOption.webrtcType

            BJY.init({
                env: options.env,
                privateDomainPrefix: options.prefixName,
                class: classOption,
                user: {
                    number: options.user_number,
                    avatar: options.user_avatar,
                    name: options.user_name,
                    type: Number(options.user_role),
                },
                teacher: {},
                sign: options.sign,
            })
        },
        onClickFoldBtn() {
            this.isShowTabContainer = !this.isShowTabContainer
            this.$nextTick(() => {
                eventEmitter.trigger(eventEmitter.WINDOW_RESIZE)
            })
        },
        // 支持解析输入的url进教室
        urlParser(url) {
            var params = {}
            if (url) {
                try {
                    var queryStr = url.split('?')[1]
                    var paramList = queryStr.split('&')
                    paramList.forEach((item) => {
                        var pair = item.split('=')
                        params[pair[0]] = pair[1]
                    })
                    // 区分环境
                    params.env = this.getEnv(url)
                    // 个性域名
                    params.prefixName = url.split('.')[0].split('//')[1]
                } catch (e) {
                    alert('url格式错误，已进入默认教室')
                }
            }
            return params
        },
        getEnv(url) {
            // 获取环境
            let hostName = url.match(/\/\/(.*)\./)[1]
            if (/test/.test(hostName) || /localhost/.test(hostName) || /\d{1,3}\.\d{1,3}\.\d{1,3}/.test(hostName)) {
                return 'test'
            }
            if (/beta/.test(hostName)) {
                return 'beta'
            }
            if (/www/.test(hostName)) {
                return ''
            }
            return ''
        },
        handleClassStart() {
            eventEmitter.trigger(eventEmitter.CLASS_START_TRIGGER)
        },
    },
    beforeDestroy() {
        // 如果直播间集成到单页面应用中，需要销毁直播间、解绑外层监听的事件、销毁通过 create 方式创建的组件（如 BJY.Whiteboard.create(...), 通过组件实例的 destroy 方法销毁）
        eventEmitter.off(this.namespace)
        BJY.dispose(BJY.config.BJY_DISPOSE_TYPE_OUT_ROOM)
        this.loaded = false
    },
}
</script>

<style lang="scss">
@import './base.css';
@import './assets/iconfont/iconfont.css';

.bjy-popup,
.bjy-enter-fullscreen,
.bjy-watermark {
    display: none !important;
}
.bjy-float {
    .bjy-toggle {
        display: none !important;
    }
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100vh;
    width: 100vw;

    #main {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 1;
        overflow: hidden !important;

        .class-panel {
            position: absolute;
            top: 0;
            left: 0;
            right: 290px;
            bottom: 40px;
            background-image: url('./assets/img/class-panel-bg.jpg');

            .start-btn {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
                margin: auto;
                background: #1795ff;
                border-radius: 5px;
                width: 100px;
                height: 50px;
                line-height: 50px;
                color: #fff;
                text-align: center;
                font-size: 22px;
                cursor: pointer;
            }

            .bjy-popup {
                display: none;
            }
        }

        .media-panel {
            position: absolute;
            width: 290px;
            top: 0;
            right: 0;
            bottom: 40px;
            padding: 8px 12px;
            box-sizing: border-box;
            background: #fff;
            box-shadow: -2px 0 6px rgba(0, 0, 0, 0.1);
            z-index: 1;

            .live-teacher-player {
                background: #000;
                height: 200px;
                width: 100%;
            }

            .wrap {
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                background: #fff;
                #live-teacher-player {
                    height: 200px;
                }
            }
        }

        .footer {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 40px;
            background-color: #313847;
            display: flex;
            justify-content: space-between;
            padding: 0 15px;
            align-items: center;
            font-size: 15px;
            color: #bdc6cf;
            z-index: 1;
            border-top: 1px solid rgba(255, 255, 255, 0.2);
        }
    }
}

#survey-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    iframe {
        width: 100%;
        height: 100%;
        border: none;
    }
}

.fold-btn {
    width: 16px;
    height: 80px;
    position: absolute;
    top: 50%;
    right: 290px;
    transform: translate(100%, -50%);
    z-index: 9;
    background: rgba($color: #333, $alpha: 0.9);
    color: #fff;
    border-radius: 0 8px 8px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    cursor: pointer;
    opacity: 0.5;
    &:hover {
        opacity: 1;
    }
    &.fold-btn-left {
        background: rgba($color: #fff, $alpha: 0.9);
        color: #000;
        border-radius: 8px 0 0 8px;
        right: 0;
        transform: translate(0, -50%);
    }
}
</style>
